<template>
    <ion-page>
      <div class="overlay" v-if="currentTab !== 'match-detail'">
        <ion-toolbar lines="none" translucent class="menu-toolbar">
          <ion-buttons slot="start" @click="goPrev()">
            <div class="pl-05">
              <ion-icon :icon="chevronBackOutline" size="large" />
            </div>
          </ion-buttons>
          <ion-title size="medium" class="notranslate">{{appTitle}}</ion-title>
        </ion-toolbar>
      </div>
      <ion-grid :scroll-x="true" class="option-row ml-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
        <ion-chip v-for="option in submenu" :key="option" @click="currentOption = option" :class="{
          'mt-20': true,
          chip: true,
          active: option === currentOption,
          selectable: option !== currentOption
        }">
          <ion-label >{{ option }}</ion-label>
        </ion-chip>
      </ion-grid>
      <ion-grid v-if="availableRounds.length" :scroll-x="true" class="date-row d-flex" style="{'align-items': 'center', 'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
        <div :class="{
          'mr-30': true,
          dateOption: true,
          active: round === false,
          selectable: round !== false
        }" @click="round = false">
          <!-- <span> {{ roundFilter }} </span> -->
          <span class="format"> ALL ROUNDS </span>
        </div>
          <div v-for="{format, round: roundNumber } in sortBy(availableRounds, 'round')" :key="format" :class="{
            'mr-30': true,
            dateOption: true,
            active: round === roundNumber,
            selectable: round !== roundNumber
          }" @click="round = roundNumber">
            <!-- <span> {{ roundNumber }} </span> -->
            <span v-if="Number.isInteger(roundNumber)" class="format"> {{ format }} </span>
            <span v-else class="format"> {{ format }} </span>
          </div>
      </ion-grid>
      <ion-content class="menu-content">
        <div class="competition-section-desktop">
          <div v-for="day in Object.keys(groupedByDay)" :key="day">
            <h3 class="c-white pl-10 mb-2">{{ day }}</h3>
            <MatchCardDesktop :match="match"  v-for="match in groupedByDay[day]" :key="match._id" class="match-card" />
          </div>
        </div>
        <div class="competition-section">
          <div v-for="day in Object.keys(groupedByDay)" :key="day">
            <h5 class="c-white pl-20 mb-1">{{ day }}</h5>
            <MatchCard :match="match"  v-for="match in groupedByDay[day]" :key="match._id"  class="match-card" />
          </div>
        </div>
        <div class="d-flex justify-center" v-if="!filteredMatches.length">
          <h5 class="text-center c-white">No Matches Available</h5>
        </div>
      </ion-content>
    </ion-page>
  </template>
  
<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  chevronBackOutline,
  menuSharp,
  closeOutline
} from "ionicons/icons";
import { menuController } from "@ionic/vue";
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { mapGetters } from "vuex";
import TeamLogo from '../matches/base/team-logo.vue'
import CompetitionCard from '../../components/CompetitionCard.vue'
import MatchCard from '../../components/MatchCard.vue'
import MatchCardDesktop from '../../components/MatchCardDesktop.vue'
import _ from 'lodash';
import moment from "moment";
// import moment from 'moment';
export default {
  components: {
    TeamLogo,
    CompetitionCard,
    MatchCard,
    MatchCardDesktop,
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      chevronBackOutline,
      caretDownOutline,
      closeOutline,
      menuSharp
    }
  },
  data() {
    // const { filter } = this.$store.state.matches;
    return {
      sortBy: _.sortBy,
      get: _.get,
      matches: [],
      key: 1,
      submenu: ['All', 'LIVE', 'Pre-Game', 'Final', 'Forfeited'],
      loading: false,
      competition: undefined,
      competitions: [],
      currentOption: 'All',
      round: false,
    };
  },
  created() {
    this.searchstate = _.debounce(async function(e) {
      const search = e.target.value;
      this.loading = true;
      const resComp = await this.$http.get(`/assemble/api/v1/live/matches/competitions/${this.$route.params.id}`);
      this.matches = resComp.data.data.matches;
      this.changeDateTimeToTimezone([{
        matches: this.matches
      }]);
      this.competition = resComp.data.data.competition;
      this.loading = false;
      // add to top of recently viewed local storage, type competition, maximum 3 items
      const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      const newRecentlyViewed = [
        { type: 'competition', entity: this.competition }, 
        ...recentlyViewed.filter(item => item.entity._id !== this.competition._id)
      ].slice(0, 5);
      localStorage.setItem('recentlyViewed', JSON.stringify(newRecentlyViewed));
      this.key++;
    }, 500);
  },
  async mounted() {
    try {
      this.$store.dispatch('national/setup');
      this.loading = true;
      const resComp = await this.$http.get(`/assemble/api/v1/live/matches/competitions/${this.$route.params.id}`);
      this.matches = resComp.data.data.matches;
      this.changeDateTimeToTimezone([{
        matches: this.matches
      }]);
      this.competition = resComp.data.data.competition;
      this.loading = false;
      // add to top of recently viewed local storage, type competition, maximum 3 items
      const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
      const newRecentlyViewed = [
        { type: 'competition', entity: this.competition }, 
        ...recentlyViewed.filter(item => item.entity._id !== this.competition._id)
      ].slice(0, 5);
      localStorage.setItem('recentlyViewed', JSON.stringify(newRecentlyViewed));
      this.key++;
    } catch (error) {
      console.log(error); 
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  computed: {
    ...mapGetters('national', ['timezone']),
    appTitle() {
      return this.competition ? this.competition.name : process.env.VUE_APP_BANNER_TITLE;
    },
    availableRounds() {
      const matches = this.matches;
      matches.forEach((item) => {
        if (item.round.type.toLowerCase() == 'regular') {
          item.round.arrange = item.round.number;
        } else if (item.round.type.toLowerCase() == 'final') {
          item.round.arrange = item.round.displayName;
        }
      });
      const regularRounds = _.filter(matches, (m) => m.round.type === 'Regular');
      const finalRounds = _.filter(matches, (m) => m.round.type === 'Final');
      const mappedRoundNumbers = _.map(regularRounds, 'round.number');
      const uniqueRoundNumbers = _.uniq(mappedRoundNumbers);
      const lastRegularRoundNumber = _.max(uniqueRoundNumbers);
      regularRounds.forEach((item) => {
        item.round.arrange = item.round.number;
      });
      finalRounds.forEach((item) => {
        item.round.arrange = item.round.number + lastRegularRoundNumber;
      });
      const orderedRegularRounds = _.orderBy(regularRounds, 'round.number', 'desc');
      const orderedFinalRounds = _.orderBy(finalRounds, 'round.number', 'desc');
      const combinedMatches = [...orderedRegularRounds, ...orderedFinalRounds];
      const groupedCombinedMatches = _.groupBy(combinedMatches, 'round.arrange');
      const combinedRounds = _.sortBy(groupedCombinedMatches, group => combinedMatches.indexOf(group[0]));
      const rounds = Object.keys(combinedRounds).map(key => ({
        round: _.get(combinedRounds[key][0], 'round.arrange'),
        format: _.get(combinedRounds[key][0], 'round.displayName'),
        dateTime: _.get(combinedRounds[key][0], 'dateTime', 0),
      }));

      return rounds.filter((round, index) => {
        return rounds.findIndex((r) => r.format === round.format) === index;
      });
    },
    roundFilteredMatches() {
      const matches = _.orderBy(this.matches, ['round.number', 'desc'], ['round.type', 'desc']);
      const regularRounds = _.filter(matches, (m) => m.round.type === 'Regular');
      const finalRounds = _.filter(matches, (m) => m.round.type === 'Final');
      const mappedRoundNumbers = _.map(regularRounds, 'round.number');
      const uniqueRoundNumbers = _.uniq(mappedRoundNumbers);
      const lastRegularRoundNumber = _.max(uniqueRoundNumbers);
      regularRounds.forEach((item) => {
        item.round.arrange = item.round.number;
      });
      finalRounds.forEach((item) => {
        item.round.arrange = item.round.number + lastRegularRoundNumber;
      });
      const roundFiltered = !this.round ? matches : _.filter(matches, m => m.round.arrange === this.round);
      const nextRoundFiltered = !this.round ? this.matches : _.filter(this.matches, m => m.round.number === this.round + 1);
      const isComplete = _.every(roundFiltered, (rnd) => rnd.status === 'final');
      const teamFiltered = !this.team
        ? roundFiltered
        : _.filter(
          roundFiltered,
          m =>
            ( m.homeTeam && m.homeTeam.name === this.team)
            ||
            (m.awayTeam && m.awayTeam.name === this.team)
        );
        
      if(isComplete) {
        const nextTeamFiltered = !this.team
          ? nextRoundFiltered
          : _.filter(
            nextRoundFiltered,
            m =>
              ( m.homeTeam && m.homeTeam.name === this.team)
            ||
            (m.awayTeam && m.awayTeam.name === this.team)
          );
        return _.orderBy([...teamFiltered, ...nextTeamFiltered], 'round.number');
      }

      return teamFiltered;
    },
    filteredMatches() {
      if (this.currentOption === 'All') {
        return this.roundFilteredMatches;
      }
      switch (this.currentOption) {
      case 'Pre-Game':
        return this.roundFilteredMatches.filter(match => match.status === 'pre-game');
      case 'Final':
        return this.roundFilteredMatches.filter(match => match.status === 'final' || match.status === 'washout' || match.status === 'forfeit');
      case 'LIVE':
        return this.roundFilteredMatches.filter(match => !['final', 'forfeit', 'pre-game', 'washout'].includes(match.status));
      case 'Forfeited':
        return this.roundFilteredMatches.filter(match => match.status === 'forfeit');
      default:
        return this.roundFilteredMatches;
      }
    },
    groupedByDay() {
      if (!this.filteredMatches.length) return {};
      const grouped = _.groupBy(this.filteredMatches, (m) => {
        return moment(m.dateTime).format('dddd, MMMM Do YYYY');
      });
      return grouped
    }
  },
  methods: {
    changeDateTimeToTimezone(pools) {
      const timezoneClients = [21, 22];
      if (!timezoneClients.includes(+process.env.VUE_APP_NATIONAL_ID)) {
        return;
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const pool of pools) {
        const { matches } = pool || {};
        // eslint-disable-next-line no-restricted-syntax
        for (const match of matches) {
          const dateTimeTimezone = utcToZonedTime(match.dateTime, this.timezone);
          match.dateTime = dateTimeTimezone.valueOf();
          match.dateTimeTimezone = dateTimeTimezone;
        }
      }
    },
    menuNavigation(url){
      menuController.close("side");
      if(this.entity && this.entityLevel && this.entityName){
        url = `/c/${this.entityLevel}/${this.entityName}${url}`
      }
      this.$router.push(url);
    },
    goPrev() {
      this.$router.go(-1);
    },
    openMenu() {
      // menuController.enable(true, 'side');
      menuController.open('side');
    },
  },
  // when _id change, run mounted again
  watch: {
    '$route.params.id': {
      handler: async function (val, oldVal) {
        // if not /competitions/id, ignore 
        console.log({ routePath: this.$route.path })
        if (!this.$route.path.includes('competitions')) return;
        try {
          this.$store.dispatch('national/setup');
          this.loading = true;
          const resComp = await this.$http.get(`/assemble/api/v1/live/matches/competitions/${this.$route.params.id}`);
          this.matches = resComp.data.data.matches;
          this.changeDateTimeToTimezone([{
            matches: this.matches
          }]);
          this.competition = resComp.data.data.competition;
          this.loading = false;
          // add to top of recently viewed local storage, type competition, maximum 3 items
          const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
          const newRecentlyViewed = [
            { type: 'competition', entity: this.competition }, 
            ...recentlyViewed.filter(item => item.entity._id !== this.competition._id)
          ].slice(0, 5);
          localStorage.setItem('recentlyViewed', JSON.stringify(newRecentlyViewed));
          this.key++;
        } catch (error) {
          console.log(error); 
        }
      },
      deep: true
    }
  }

};
</script>
  <style scoped lang="scss">
  
  ion-title {
    font-family: 'Cairo';
  }
  
  ion-grid {
    white-space: nowrap;
     --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  
  ion-segment {
    --background: #191a1d !important;
  }

  h5 {
    font-family: 'BrownStd-Bold';
    letter-spacing: -0.03rem;
  }

  .date-row {
    max-height: 3rem;
    width: 100%;
    align-items: center;
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    padding: 0rem 1.5rem;
    background: $background !important;
    border-bottom: 1px solid #3a3a3a;
  }

  .dateOption {
    display: flex;
    flex-direction: column;
    align-items: center;
    // gap: 0.25rem;
    span {
      color: #a9a9a9;
      font-size: 0.8rem;
      font-family: 'Cairo';
      transition: all 0.2s ease-in-out;
    }

    .date {
      font-size: 1rem;
    }

    &.active {
      // background: white;
      // color: var(--ion-color-primary);
      span {
        // font-size: 0.9rem;
        color: white !important;
        font-family: 'Cairo';
      }
    }

    &.selectable {
      cursor: pointer;
      color: #fff;
      // background: #1E1F22;
    }
  }
  
  .team-logo-preview {
    display: flex;
    .club-logo {
      margin-right: -0.5rem;
      z-index: 10;
    }
    margin-bottom: 2rem;
  }
  
  .team-plus {
    width: 2rem;
    height: 2rem;
    background: rgb(52, 52, 52);
    border: 1px solid #3c3c3c;
    color: white;
    border-radius: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.8rem;
  }
  .option-row {
    position: relative;
    width: 100%;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      width: 5px; /* Adjust the width as needed */
      height: 100%;
      background: linear-gradient(to left, transparent, $background); /* Change to your background color */
      pointer-events: none; /* Allow clicks to pass through */
    }
    max-height: 5rem !important;
    display: flex;
    --offset-bottom: auto!important;
    --overflow: hidden;
    overflow: auto;
    &::-webkit-scrollbar {
      display: none;
    }
    background: $background !important;
  }
  
  .competition-section-desktop {
    display: grid;
    grid-template-columns: 1fr;
    // gap: 0.5rem;
    padding: 1rem 1.5rem;
    @media screen and (max-width: 1080px) {
      display: none;
    }
  }
  .competition-section {
    display: grid;
    grid-template-columns: 1fr;

    @media screen and (min-width: 1080px) {
      display: none;
    }
    
    // on larger screen make it bigger
    @media only screen and (min-width: 768px) {
    //   grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
      padding: 0.75rem;
    }
    // gap: 0.5rem;
    // padding: 1rem 1rem;
    .competition-option {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // align-items: center;
      // gap: 0.5rem;
      background: #17181B;
      border-radius: 1rem;
      padding: 1rem 1rem;
      // min-width: 10rem;
    }
  }
  
  
  .chip {
    font-size: 1rem;
    color: #a9a9a9;
    font-family: 'Cairo';
    &.active {
      background: var(--highlight-color);
      ion-label {
        color: #000;
      }
      // color: var(--ion-color-primary);
      font-family: 'Cairo';
    }
  
    &.selectable {
      cursor: pointer;
      color: #a9a9a9;
      background: #1E1F22;
    }
  }
  
  .header-bar {
    padding: 0.5rem;
  }
  
  .search-bar {
    color: #fff;
    margin: 1rem 2rem;
    max-width: 85%;
    background: #191a1d !important;
    border: 1px solid #616161;
    border-radius: 1rem;
    .searchbar-input-container { 
      
    }
  }
  
  
  .round-text {
    color: #fff;
    font-family: 'Cairo';
    text-align: center;
    font-size: 14px;
    text-transform: uppercase;
    // text-decoration: underline;
    // text-decoration-color: $highlight;
  }
  
  .state-list {
    margin: 1rem;
    display: grid;
    grid-template-columns: 1fr;
    // gap: 0.5rem;
    .state-option {
      display: grid;
      // flex-direction: column;
      // justify-content: center;
      align-items: center;
      gap: 0.5rem;
      background: #17181B;
      border-radius: 1rem;
      padding: 1rem 1rem;
    }
  }
  
  ion-label {
    color: white;
    font-family: 'Cairo';
    font-size: 0.8rem;
  }
  
  
  ion-item {
    --padding-start: 15px;
    --padding-end: 15px;
  }
  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .align-center {
    align-items: center;
  }
  .justify-end {
    justify-content: flex-end;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-around {
    justify-content: space-around;
  }
  .light-text {
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
  }
  .normal-text {
    font-size: 15px;
    font-weight: 600;
    text-transform: capitalize;
  }
  .bold-text {
    font-size: 16px;
    font-weight: bold;
  }
  .score-text {
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
    /* color: rgba(8, 48, 109, 0.5); */
    color: white;
  }
  
  .header {
    --background: #1a2933 !important;
    color: white;
  }
  
  .custom-segment {
    background: $background !important;
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  ion-segment-button::part(indicator-background) {
    background: hsl(225, 7%, 16%);
  }
  
  /* Material Design styles */
  ion-segment-button.md {
    --color: white;
    --color-checked: #191a1d;
    --indicator-height: 4px;
  }
  
  /* iOS styles */
  ion-segment-button.ios {
    --color: white;
    --color-checked: #191a1d;
    --border-radius: 20px;
  }
  
  .bye-card {
    margin-inline: 1.5rem;
    position: relative;
    border-radius: 24px;
    cursor: pointer;
    box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    
    font-family: 'BrownStd-Regular';
    color: white;
    background: transparent;
    .round-text {
      margin-top: 0.5rem;
      margin-bottom: 1rem;
    }
  }
  .custom-card {
    border-radius: 24px;
    cursor: pointer;
    // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
    font-family: 'BrownStd-Regular';
    font-size: 1.2rem;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: white;
     box-shadow: none;
    background: #171717 !important;
    margin-inline: 1rem;
    margin-top: 0;

    @media screen and (min-width: 768px) {
      margin-inline: 0.5rem;
    }
  }
  .custom-card .card-content-ios {
    padding: 10px;
  }
  
  .custom-card .promoted-header {
    font-family: 'BrownStd-Regular';
    text-align: center;
    font-size: .9rem;
    font-weight: 600;
    text-transform: capitalize;
    line-height: 137.4%;
    letter-spacing: 0.02em;
    color: #2d3a45;
  }
  
  .list-ios, .list-md {
    padding: 0;
    background: 0;
  }
  
  ion-item {
    --background: #232528;
    --color: white;
  }
  
  .custom-segment ion-label {
    margin-bottom: 0;
  }
  
  ion-content {
    background: $background;
    --background: $background;
  }
  
  ion-content::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: rgba(0,0,0,0.3);
  }
  
  ion-content::-webkit-scrollbar
  {
    width: .35rem;
    background-color: rgba(0,0,0,0.3);
  }
  
  @media only screen and (max-width: 768px) {
    ion-content::-webkit-scrollbar {
      width: .15rem;
      background-color: rgba(0,0,0,0.3);
    }
  }
  
  ion-content::-webkit-scrollbar-thumb
  {
    background-color: #888;
  }
  
  
  .overlay {
    background: $background;
    // background: $primary;
    padding: 0rem;
  }
  
  ion-toolbar, ion-item {
    --border-width: 0 !important;
    --background: $background;
    --color: white;
  }
  
  ion-segment-button {
    --background-hover: #191a1d !important;
    --color-hover: #191a1d !important;
    --color-checked: #191a1d !important;
  }
  
  .custom-segment {
    border: none;
    /* background: white; */
    border-radius: 0px;
    border-bottom: 1px solid rgba(177, 177, 177, 0.3);
    // padding-top: 1rem;
    border: none;
    background: none;
     display: flex;
    // justify-content: center;
    /* border-radius: 1rem !important; */
  }
  
  .custom-segment ::before {
    border-left: none;
  }
  
  .custom-segment-ladder {
    // border: none;
    margin: 0 auto;
    margin-top: 1rem;
    display: flex;
    width:70%;
    justify-content: center;
    border-radius: 0.6rem !important;
  }
  
  .custom-segment-ladder-button{
    flex-basis: 50%;
  }
  
  
  .custom-segment-ladder ::before {
    border-left: none;
  }
  
  .empty-container {
    height: 60vh;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-container ion-card {
    padding: 4rem;
    border-radius: 1rem;
    background: transparent;
    box-shadow: none;
    -webkit-box-shadow: none;
  }
  
  .empty-placeholder {
    align-items: flex-start;
    font-family: 'BrownStd-Regular';
    font-style: normal;
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 137.4%;
    /* margin-bottom: 1rem; */
    padding-left: 0;
  
    letter-spacing: 0.02em;
  
    color: white;
  }
  
  .state-name {
    font-size: 0.8rem;
    white-space: break-spaces;
  }
  
  ion-select::part(icon) {
    margin-left: 0.5rem;
    color: white !important;
    opacity: 0.85;
  }
  
  </style>